import {useEffect, useState} from 'react';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Space,
  TreeSelect,
} from 'antd'
import {SDrawer, STitle} from 'shj-components';
import dayjs from 'dayjs'
import {getEnums} from '@/services/homeService'
import {trimObj} from "@/utils/data.ts";
import {
  evaluationConf,
  evaluationMetricsConditionList,
  getRoleList, getTreeEvaluationType,
  saveEvaluation,
} from '@/services/evaluateConfig'
import {httpDictServ} from '@/services/customerServices';
import moment from 'moment';
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons';
import styles from '../../index.module.less'
import {isArray} from "lodash-es";

const { RangePicker } = DatePicker;
const Add = (props: any) => {
    const [form] = Form.useForm();
    const { visibleDrawer = false, closeDetails, reloadList, record } = props
    const [loading, setLoading] = useState(false);
    const [evaluationServiceTypeList, setEvaluationServiceTypeList] = useState([]);
    const [evaluationCategoryEnum, setEvaluationCategoryEnum] = useState([]);
    const [typeList, setTypeList] = useState([]);
    const [bizOpTypeEnum, setBizOpTypeEnum] = useState([]);
    const [evaluationDimensionList, setEvaluationDimensionLsit] = useState([])
    const [roleList, setRoleList] = useState([])
    // 版本迭代
    const [metricsCategoryEnumList, setMetricsCategoryEnumList] = useState([])//指标维度
    const [deliveryModelList, setDeliveryModelList] = useState([])//交付模式
    const [tagObj, setTaObj] = useState({})//评分标签-下拉使用
    const arrLabel = ['oneStarLabel','twoStarLabel','threeStarLabel','fourStarLabel','fiveStarLabel','sixStarLabel','sevenStarLabel','eightStarLabel','nineStarLabel','tenStarLabel'];//回显标签
    useEffect(() => {
        if (visibleDrawer) {
            form.resetFields();
            setLoading(false);
            setTaObj({});
            setEvaluationDimensionLsit([]);
            initFn();
        }
    }, [visibleDrawer])

    const disableNonLeafNodes = (list: any) => {
      if (!Array.isArray(list)) return [];
      return list.map((node: { children: string | any[] }) => {
        const hasChildren = Array.isArray(node.children) && node.children.length > 0
        return {
          ...node,
          disabled: hasChildren, // 非叶子节点禁用
          children: hasChildren ? disableNonLeafNodes(node.children) : [],
        }
      })
    };

    const initFn = async () => {
        if (record.id) {
            setLoading(true)
            evaluationConf(record?.id).then(async (res) => {
                if (res.pushValidityPeriodStart && res.pushValidityPeriodEnd) {
                    res.pushValidityPeriod = [dayjs(res.pushValidityPeriodStart), dayjs(res.pushValidityPeriodEnd)]
                }
                httpDictServ({ parentKey: res['evaluationServiceType'], enable: 1, }).then((res: any) => {
                    setEvaluationDimensionLsit(res);
                })

                // 处理标签回显数据
                if (res.questionList && res.questionList.length > 0) {
                    const evaluationServiceType = res.evaluationServiceType || "";
                    try {
                        await Promise.all(res.questionList.map(async (item, index) => {
                            item.tagVal = item?.sourceMetricsObj?.id; // 更新 item 的 tagVal 属性
                            await getEvaluationMetricsConditionList(`${index}`, {
                                ...item,
                                evaluationServiceType,
                            }, true);
                            return item;
                        }));
                    } catch (error) {}
                }
                form.setFieldsValue(res);
            }).finally(()=>{
                setLoading(false)
            })
        }
        // 服务类型列表
        const evaluationServiceTypeList: any = await httpDictServ({ parentKey: 'evaluationServiceType', enable: 1, });
        setEvaluationServiceTypeList(evaluationServiceTypeList);
        // 评价类别枚举
        const evaluationCategoryEnum: any = await getEnums("plus-member", "com.shj.saas.plus.member.enums.EvaluationCategoryEnum");
        setEvaluationCategoryEnum(evaluationCategoryEnum.filter(item => item.description != '订单评价'));
        // 查询角色列表
        const roleList: any = await getRoleList(
            {
                "roleType": "SYSTEM",  //只查内置角色
                "enabled": true   //启用的
            }
        );
        setRoleList(roleList);
        // 问题分类
        const typeList: any = await getTreeEvaluationType({});
        setTypeList(disableNonLeafNodes(typeList));
        // 需求类型枚举
        const bizOpTypeEnum: any = await getEnums("plus-member", "com.shj.saas.plus.crm.enums.BizOpTypeEnum");
        setBizOpTypeEnum(bizOpTypeEnum);
        // 指标维度列表
        const metricsCategoryEnumList: any = await getEnums("plus-member", "com.shj.saas.plus.member.enums.MetricsCategoryEnum");
        setMetricsCategoryEnumList(metricsCategoryEnumList)

        // 交付模式
        const deliveryModelList: any = await getEnums("plus-member", "com.shj.saas.pms.enums.project.DeliveryMode");
        setDeliveryModelList(deliveryModelList)
    }
    const onSubmit = (status) => {
        form.validateFields().then((values: any) => {
            setLoading(true)
            let formObj = {
                ...values,
                "status": status,
                "deliveryModel": values?.deliveryModel||"",
                "pushValidityPeriodStart": dayjs(values.pushValidityPeriod[0]).valueOf(),
                "pushValidityPeriodEnd": dayjs(values.pushValidityPeriod[1]).valueOf(),
            }
            formObj = trimObj(formObj, 'trim');
            console.log(111,formObj)
            saveEvaluation({
                ...formObj
            }).then((res) => {
                setLoading(false)
                message.success(res.message || "操作成功")
                reloadList()
                closeDetails()
            }).catch(() => {
                setLoading(false)
            })
        })
    };
    const joinArr = (obj)=>{
        if (!obj || typeof obj !== 'object' || Array.isArray(obj)) {
            return '无';
        }
        const newObj = JSON.parse(JSON.stringify(obj));
        const list = [];
        arrLabel.forEach((key) => {
            if (Array.isArray(newObj[key]) && newObj[key].length > 0) {
                newObj[key][0] = `${arrLabel.indexOf(key) + 1}星：${newObj[key][0]}`;
                list.push(...newObj[key]);
            }
        });
        // 返回结果字符串
        return list.length > 0 ? list.join('；') : '无';
    }

    // 清空默认值
    const clearDefaultValues = (tagObj: any, name: string) => {
        const obj = {...tagObj};
        obj[name] = [];
        setTaObj(obj);
    }
    // 设置下拉标签
    const setDropdownTags = (list: any[], tagObj: any, name: string) => {
        tagObj[name] = list;
        setTaObj(tagObj);
    }
    const setDefaultFirstItem = (form: any, questionList: any, name: string, list: any[]) => {
        if (isArray(list) && list.length > 0) {
            questionList[name] = questionList[name] || {}; // 确保 questionList[name] 存在
            questionList[name]['tagVal'] = list[0].id;
            questionList[name]['sourceMetricsObj'] = list[0];
            form.setFieldsValue({questionList: questionList});
        }
    }
    // 分数标签列表
    const getEvaluationMetricsConditionList = async (name, value, isEdit?: boolean) => {
        // 主逻辑
        try {
            // 清空默认值
            if (!isEdit) {
                clearDefaultValues(tagObj, name);
            }
            const {evaluationServiceType, evaluationCategory, evaluationDimension, metricsCategory} = value;
            const evaluationServiceTypeVal = form.getFieldValue('evaluationServiceType') || evaluationServiceType;
            // 校验必填字段
            if (!evaluationServiceTypeVal || !evaluationCategory || !evaluationDimension || !metricsCategory) {
                return;
            }
            // 获取评价指标条件列表
            let list: any = await evaluationMetricsConditionList({
                orderBys: [{columnName: "id", asc: false}],
                queryEvaluationDimensionDesc: true,
                evaluationCategory,
                evaluationDimension,
                metricsCategory,
                evaluationServiceType: evaluationServiceTypeVal,
            });
            // 处理列表数据
            if (isArray(list)) {
                list = list.map((item) => {
                    if (item && typeof item === 'object') {
                        item.tagName = joinArr(item);
                    }
                    return item;
                });
            } else {
                list = []; // 确保 list 是数组
            }
            // 设置下拉标签
            setDropdownTags(list, tagObj, name);
            // 设置默认第一项
            if (!isEdit) {
                const questionList = form.getFieldValue('questionList') || {};
                setDefaultFirstItem(form, questionList, name, list);
            }
        } catch (error) {
            console.error("Error in processing evaluation metrics:", error);
            // 处理异常
        }
    }
    // 更新表单数据
    const updateQuestionListAndTrigger = (form, name, updatedFields, getEvaluationMetricsConditionList) => {
        try {
            const questionList = form.getFieldValue('questionList');
            if (!questionList[name]) {
                console.warn(`questionList[${name}] is undefined`);
                return;
            }

            // 更新指定对象的属性
            const updatedQuestion = {
                ...questionList[name],
                ...updatedFields,
            };
            console.log(updatedQuestion)
            // 更新表单字段值
            form.setFieldsValue({
                questionList: {
                    ...questionList,
                    [name]: updatedQuestion
                }
            });
            // 调用外部函数并捕获异常
            if(getEvaluationMetricsConditionList){
                getEvaluationMetricsConditionList(name, updatedQuestion);
            }
        } catch (error) {
            console.error("Error in updateQuestionListAndTrigger:", error);
            // 提示用户操作失败
            message.error("操作失败，请稍后重试");
        }
    };
    const questionListDom = (field: any, remove: any) => {
        const { key, name, ...restField } = field;
        const tagName = String(name);
        const tagList = (isArray(tagObj[tagName])) ? tagObj[tagName] : [];
        return (
            <div className={styles.evaluateConfigForm} key={key}>
                <div className={styles.dynamicDeleteButton}>
                    <MinusCircleOutlined
                        key={key}
                        style={{color:'rgba(250, 96, 80, 1)',fontSize:'18px'}}
                        onClick={() => {
                            remove(name);
                        }}
                    />
                </div>
                <div className={styles.evaluateConfigFormItem}>
                    <Row gutter={10}>
                        <Col span={8}>
                            <Form.Item
                                key={key + 1}
                                {...restField}
                                name={[name, 'questionName']}
                                label={`问题【${name + 1}】名称`}
                                rules={[{ required: true, message: '请输入问题名称' }]}
                            >
                                <Input onChange={e => {
                                    updateQuestionListAndTrigger(
                                        form,
                                        name,
                                        {
                                            questionName: e?.target?.value||"",
                                        },
                                        false
                                    );
                                }} />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                key={key}
                                {...restField}
                                name={[name, 'typeId']}
                                label="问题分类"
                                rules={[{ required: true, message: '请选择' }]}
                            >
                                <TreeSelect
                                  placeholder="请选择"
x                                  fieldNames={{
                                    label: 'label',
                                    value: 'id',
                                  }}
                                  treeData={typeList || []}
                                  allowClear
                                  showSearch
                                  filterTreeNode={(inputValue: any, treeNode: any) => {
                                      return treeNode?.label?.toLowerCase()?.indexOf(inputValue?.toLowerCase()) >= 0
                                  }}
                                  onChange={(id, node) => {
                                      updateQuestionListAndTrigger(
                                          form,
                                          name,
                                          {
                                              typeId: id||"",
                                              typeName:isArray(node)&&node.length>0?node[0]:"",
                                          },
                                          false
                                      );
                                  }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                key={key}
                                {...restField}
                                name={[name, 'evaluationCategory']}
                                label="评价类别"
                                rules={[{ required: true, message: '请选择' }]}
                            >
                                <Select
                                    placeholder="请选择"
                                    allowClear
                                    showSearch
                                    fieldNames={{ label: 'description', value: 'key' }}
                                    filterOption={(input, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    onChange={(id) => {
                                        updateQuestionListAndTrigger(
                                            form,
                                            name,
                                            {
                                                evaluationCategory: id,
                                                evaluationDimension: "",
                                                tagVal: ""
                                            },
                                            getEvaluationMetricsConditionList
                                        );
                                    }}
                                    options={evaluationCategoryEnum}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                key={key}
                                {...restField}
                                name={[name, 'evaluationDimension']}
                                rules={[{ required: true, message: '请选择' }]}
                                label="评价对象"
                            >
                                <Select
                                    placeholder="请选择"
                                    allowClear
                                    showSearch
                                    optionFilterProp={'name'}
                                    options={form.getFieldValue('questionList')[name]?.['evaluationCategory'] == 'projectEvaluation' ? evaluationDimensionList : roleList}
                                    fieldNames={{ label: 'name', value: form.getFieldValue('questionList')[name]?.['evaluationCategory'] == 'projectEvaluation' ? 'priKey' : 'code' }}
                                    onChange={(priKey) => {
                                        updateQuestionListAndTrigger(
                                            form,
                                            name,
                                            {
                                                evaluationDimension: priKey,
                                                tagVal: ""
                                            },
                                            getEvaluationMetricsConditionList
                                        );
                                    }}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                      <Col span={8}>
                        <Form.Item
                          key={key}
                          {...restField}
                          name={[name, 'metricsCategory']}
                          rules={[{ required: true, message: '请选择' }]}
                          label="指标维度"
                        >
                          <Select
                            placeholder="请选择"
                            allowClear
                            showSearch
                            optionFilterProp={'name'}
                            options={metricsCategoryEnumList}
                            fieldNames={{ label: 'description', value: 'key' }}
                            onChange={(key,o) => {
                              updateQuestionListAndTrigger(
                                form,
                                name,
                                {
                                  metricsCategory: key,
                                  metricsCategoryName: o?.description||"",
                                  tagVal: ""
                                },
                                getEvaluationMetricsConditionList
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={8}>
                        <Form.Item
                          label="标签"
                          key={key}
                          {...restField}
                          name={[name, 'tagVal']}
                          rules={[{ required: true, message: '请选择' }]}
                        >
                          <Select
                            style={{width: '100%', maxWidth: 230}}
                            placeholder="请选择"
                            allowClear
                            showSearch
                            optionFilterProp={'name'}
                            options={tagList}
                            fieldNames={{ label: 'tagName', value: 'id' }}
                            onChange={(val,obj) => {
                              console.log('标签1111',obj)
                              updateQuestionListAndTrigger(
                                form,
                                name,
                                {
                                  sourceMetricsObj:{...obj}
                                },
                                false
                              );
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                </div>
            </div>
        );
    };
    // 切换服务类型时，清空评价对象列表和值
    const clearQuestionList = (questionList: any[]) => {
        return questionList.map((item) => {
            if (item?.evaluationCategory !== 'userEvaluation') {
                return { ...item, evaluationDimension: '', tagVal: '' };
            }
            return item;
        });
    };

    return (
        <>
            <SDrawer
                width={800}
                title={record?.id ? '编辑' : '新增'}
                open={visibleDrawer}
                onClose={closeDetails}
                loading={loading}
                footer={<>
                    <Button
                        onClick={() => {
                            onSubmit('draft')
                        }}
                        style={{ marginRight: '10px' }}
                    >草稿</Button>
                    <Button type={'primary'} onClick={() => {
                        onSubmit('draft')
                    }}>保存</Button>
                </>}
                destroyOnClose
            >
                <Form
                    style={{ padding: "10px 0" }}
                    form={form}
                    layout={'vertical'}
                >
                    <Form.Item label={'id'} name={'id'} hidden>
                        <Input />
                    </Form.Item>
                    <STitle titleMode={'edit'} style={{ marginBottom: 10 }} title={'新增评价'} />
                    <Row gutter={10}>
                        <Col span={12}>
                            <Form.Item
                                label={`评价标题`}
                                name='title'
                                required={true}
                                rules={[{ required: true, message: `评价标题名称不能为空` }]}
                            >
                                <Input placeholder={`请输入`} maxLength={20} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={'服务类型'}
                                name='evaluationServiceType'
                                required={true}
                                rules={[{ required: true, message: '服务类型不能为空' }]}
                            >
                                <Select
                                    maxTagCount={1}
                                    placeholder={'请选择'}
                                    options={evaluationServiceTypeList}
                                    fieldNames={{ label: 'name', value: 'priKey' }}
                                    optionFilterProp={'name'}
                                    allowClear
                                    onChange={async (v, o) => {
                                        form.setFieldsValue({ pushConditions: "" });
                                        setEvaluationDimensionLsit([]);
                                        setTaObj({});

                                        const questionList = form.getFieldValue('questionList');
                                        if (isArray(questionList) && questionList.length > 0) {
                                            const updatedQuestionList = clearQuestionList(questionList);
                                            form.setFieldsValue({ questionList: updatedQuestionList });
                                        }

                                        try {
                                            const res = await httpDictServ({ parentKey: o['priKey'], enable: 1 });
                                            if (Array.isArray(res)) {
                                                setEvaluationDimensionLsit(res);
                                            } else {
                                                console.error('Unexpected response format:', res);
                                            }
                                        } catch (error) {

                                        }
                                    }}
                                    showSearch
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label={'说明'}
                                name='description'
                            >
                                <Input placeholder={`请输入`} maxLength={20} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.List name="questionList">
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.map((field) => questionListDom(field, remove))}
                                        <Col span={24} style={{ marginBottom: '24px' }}>
                                            <Button
                                                type="dashed"
                                                onClick={() => {
                                                    add({
                                                        metricsCategory:'professionalLevel'
                                                    })
                                                }}
                                                icon={<PlusOutlined />}
                                            >
                                                添加问题
                                            </Button>
                                        </Col>
                                    </>
                                )}
                            </Form.List>
                        </Col>
                    </Row>
                    <STitle titleMode={'edit'} style={{ marginBottom: 10 }} title={'推送规则'} />
                    <Row gutter={10}>
                        <Col span={12}>
                            <Form.Item label="推送条件" name="pushConditions" rules={[{ required: true, message: '请选择' }]}>
                                <Select
                                    placeholder="请选择"
                                    allowClear
                                    showSearch
                                    optionFilterProp={'name'}
                                    options={evaluationDimensionList}
                                    fieldNames={{ label: 'name', value: 'priKey' }}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="需求类型" name="pushDemandTypes" rules={[{ required: true, message: '请选择' }]}>
                                <Select
                                    placeholder="请选择"
                                    allowClear
                                    showSearch
                                    options={bizOpTypeEnum}
                                    mode={'multiple'}
                                    fieldNames={{ label: 'description', value: 'key' }}
                                    optionFilterProp={'description'}
                                >
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="推送有效期" name="pushValidityPeriod" rules={[{ required: true, message: '请选择' }]}>
                                <RangePicker
                                    style={{ width: '100%' }}
                                    allowClear
                                    showTime={{
                                        defaultValue: [moment(new Date(), 'HH:mm:ss'), moment(new Date(), 'HH:mm:ss')],
                                    }}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Space>
                                <Form.Item
                                    label="人工回访"
                                    name="returnVisitDays"
                                    rules={[
                                        { required: true, message: '请输入' },
                                        { pattern: new RegExp('^[0-9]*[1-9][0-9]*$', 'g'), message: '请输入正整数' },
                                    ]}
                                >
                                    <InputNumber min="1" step="1" style={{ width: '100%', marginRight: '8px' }} />
                                </Form.Item>
                                <div style={{ whiteSpace: 'nowrap' }}>天后转为待回访（推送后客户未评价）</div>
                            </Space>
                        </Col>
                      <Col span={12}>
                        <Form.Item label="交付模式" name="deliveryModel">
                          <Select
                            placeholder="请选择"
                            allowClear
                            showSearch
                            optionFilterProp={'description'}
                            options={deliveryModelList}
                            fieldNames={{ label: 'description', value: 'key' }}
                          >
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                </Form>
            </SDrawer>
        </>
    );
};
export default Add
